import {Directive, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[jhiDragDrop]'
})
export class DragDropDirective {
  @Output() fileDropped = new EventEmitter<any>();

  //listener Dragover
  @HostListener('dragover', ['$event']) onDragOver (evt: { preventDefault: () => void; stopPropagation: () => void; }): void{
    evt.preventDefault();
    evt.stopPropagation();
  }

  //listener Dragleave
  @HostListener('dragover', ['$event']) onDragLeave (evt: { preventDefault: () => void; stopPropagation: () => void; }): void{
    evt.preventDefault();
    evt.stopPropagation();
  }

  //listener Dragleave
  @HostListener('drop', ['$event']) public ondrop(evt: { preventDefault: () => void; stopPropagation: () => void; dataTransfer: { files: any; }; }): void{
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if(files.length > 0){
      this.fileDropped.emit(files);
    }
  }
}
